import moment from 'moment';
import { isCsairApp } from '@csair/emp-helpers';
import urlConfig from 'Url';
import Routes from 'Routes';

// 类型判断
export function type(o) {
  const s = Object.prototype.toString(o);
  return s.match(/\[object (.*?)\]/)[1].toLowerCase();
}

// array sort
export function compare(x, y) {
  if (x < y) {
    return -1;
  } else if (x > y) {
    return 1;
  } else {
    return 0;
  }
}

// 城市机场名过滤函数
export function cityToAirPort(city = '', airport = '') {
  let targetName;
  if (!city || city === airport) {
    targetName = airport;
  } else if (!airport || city === airport) {
    targetName = city;
  } else if (city === airport.substring(0, city.length)) {
    targetName = airport.substring(city.length, airport.length);
  } else {
    targetName = airport;
  }

  return targetName;
}

// 遍历数组中是否全部为true
export function isAllTrue(arr) {
  let i = arr.length;
  while (i--) {
    if (!arr[i]) {
      return false;
    }
  }
  return true;
}

// 设置APP头部title
// export function setAppHeaderTitle(title) {
//   try {
//     window.CSNativeObject.nativeSetTitle(title || '');
//   } catch (e) {
//     // catch exception;
//   }
// }

// 对params参数处理  返回一个由‘&’拼接的字符串
export function toQueryString(obj) {
  return obj
    ? Object.keys(obj)
      .sort()
      .map(key => {
        if (key === '' || key === null || key === undefined) {
          return false;
        }

        const val = obj[key];
        if (Array.isArray(val)) {
          return val
            .sort()
            .map(val2 => {
              return `${key}=${val2}`;
            })
            .join('&');
        }

        if (val === '' || val === undefined) {
          return false;
        }

        return `${key}=${encodeURI(val)}`;
      })
      .join('&')
    : '';
}

// 默认时间判断
export function overscroll(el) {
  el.addEventListener('touchstart', () => {
    let top = el.scrollTop,
      totalScroll = el.scrollHeight,
      currentScroll = top + el.offsetHeight;
    if (top === 0) {
      el.scrollTop = 1;
    } else if (currentScroll === totalScroll) {
      el.scrollTop = top - 1;
    }
  });
  el.addEventListener('touchmove', evt => {
    if (el.offsetHeight < el.scrollHeight) evt._isScroller = true;
  });
}

// 获得角度
function getAngle(angx, angy) {
  return (Math.atan2(angy, angx) * 180) / Math.PI;
}

// 根据起点终点返回方向 1向上 2向下 3向左 4向右 0未滑动
export function getDirection(startx, starty, endx, endy) {
  const angx = endx - startx;
  const angy = endy - starty;
  let result = 0;

  // 如果滑动距离太短
  if (Math.abs(angx) < 2 && Math.abs(angy) < 2) {
    return result;
  }

  const angle = getAngle(angx, angy);
  if (angle >= -135 && angle <= -45) {
    result = 1;
  } else if (angle > 45 && angle < 135) {
    result = 2;
  } else if (
    (angle >= 135 && angle <= 180) ||
    (angle >= -180 && angle < -135)
  ) {
    result = 3;
  } else if (angle >= -45 && angle <= 45) {
    result = 4;
  }

  return result;
}

// 解析变更使用条件
export function transformateCn(str) {
  if (/(.+)?\d(.+)?/.test(str)) {
    return str
      .replace('不得变更', 'nochange')
      .replace('不得退票', 'norefund')
      .replace(/[\u4E00-\u9FA5]/g, '')
      .replace(/[a-zA-Z]/g, '')
      .replace('()', '')
      .replace('nochange', '不得变更')
      .replace('norefund', '不得退票');
  } else if (str === '') {
    return '----,----';
  } else if (
    str.indexOf('前后退票免费') !== -1 ||
    str.indexOf('前后变更免费') !== -1
  ) {
    return '免费,免费';
  } else if (str.indexOf('前免费') !== -1) {
    return '免费';
  } else if (str.indexOf('后免费') !== -1) {
    return '免费';
  } else {
    return str.indexOf('不得变更') !== -1 && str.indexOf('不得退票') === -1
      ? '不得变更,不得变更'
      : '----,----';
  }
}

/**
 * @description 使用条件区间解析
 * @param {string} time 时间
 * @param {string} sign 'r' | 'b' r为退票、b为变更
 * @param {array} arr 子元素必须为ReissueDetails、RefundDetails
 * @returns {array} 子元素类型为 { text: string; percent: string }
 * interface ReissueDetails {
 *  appointClass: string;
 *  autoNote: string;
 *  chargeType: string,
 *  control: string;
 *  discountCalMethod: string;
 *  discountPercent: number;
 *  discountRule: string;
 *  discountType: string;
 *  flight: string;
 *  flightDateEnd: number;
 *  flightDateEndUnit: string;
 *  flightDateStart: number;
 *  flightDateStartUnit: string;
 *  free: string;
 *  freeFrequency: number;
 *  frequency: number;
 *  inadvisability: string;
 *  lowestAmount: number;
 *  ticketStatus: string;
 * }
 * interface RefundDetails {}
 * 具体字段说明看全渠道客票变更reshop响应说明
 */
export function huAnalyzeUseText(time, sign, arr, language) {
  if (language == 'en') {
    return arr
      .map(item => {
        let obj = {
          text: '',
          percent: 0,
        };
        const isEnd = item.flightDateEnd && item.flightDateEnd !== 0;
        const date = isEnd
          ? item.flightDateEnd > 0
            ? 'flightDateStart'
            : 'flightDateEnd'
          : 'flightDateStart';
        const unit = isEnd ? 'flightDateEndUnit' : 'flightDateStartUnit';
        const percentName = sign === 'r' ? 'percentage' : 'discountPercent';
        if (!item[unit] && !item[date]) return '';
        const t = moment(time)
          .subtract(Math.abs(item[date]), item[unit].toLocaleLowerCase())
          .format('YYYY-MM-DD HH:mm');

        // 前、后时间都为0
        if (!item.flightDateStart && !item.flightDateEnd) {
          return {
            text: `Around ${moment(time).format('MM-DD HH:mm')}`,
            percent: /(不得)+.*(退票|变更)+/.test(item.autoNote)
              ? '100%'
              : item[percentName] === 0 || !item[percentName]
                ? 'Free'
                : item[percentName] + '%',
            time,
          };
        }
        obj.text = `${
          // isEnd ? '前（包含）' : '后'
          isEnd
            ? item.flightDateEnd > 0
              ? `After ${moment(t).format('MM-DD HH:mm')}（excluding）`
              : `Before ${moment(t).format('MM-DD HH:mm')}（include）`
            : `After ${moment(t).format('MM-DD HH:mm')}`
          }`;
        obj.percent = /(不得)+.*(退票|变更)+/.test(item.autoNote)
          ? '100%'
          : item[percentName] === 0 || !item[percentName]
            ? 'Free'
            : item[percentName] + '%';
        obj.time = t;
        return obj;
      })
      .sort((a, b) => {
        return moment(a.time).isAfter(b.time)
          ? 1
          : moment(a.time).isSame(b.time) && a.text.indexOf('After') !== -1
            ? 1
            : -1;
      });
  } else {
    return arr
      .map(item => {
        let obj = {
          text: '',
          percent: 0,
        };
        const isEnd = item.flightDateEnd && item.flightDateEnd !== 0;
        const date = isEnd
          ? item.flightDateEnd > 0
            ? 'flightDateStart'
            : 'flightDateEnd'
          : 'flightDateStart';
        const unit = isEnd ? 'flightDateEndUnit' : 'flightDateStartUnit';
        const percentName = sign === 'r' ? 'percentage' : 'discountPercent';
        if (!item[unit] && !item[date]) return '';
        const t = moment(time)
          .subtract(Math.abs(item[date]), item[unit].toLocaleLowerCase())
          .format('YYYY-MM-DD HH:mm');

        // 前、后时间都为0
        if (!item.flightDateStart && !item.flightDateEnd) {
          return {
            text: `${moment(time).format('MM-DD HH:mm')} 前后`,
            percent: /(不得)+.*(退票|变更)+/.test(item.autoNote)
              ? '100%'
              : item[percentName] === 0 || !item[percentName]
                ? '免费'
                : item[percentName] + '%',
            time,
          };
        }

        obj.text = `${moment(t).format('MM-DD HH:mm')} ${
          // isEnd ? '前（包含）' : '后'
          isEnd ? (item.flightDateEnd > 0 ? '后（不含）' : '前（包含）') : '后'
          }`;
        obj.percent = /(不得)+.*(退票|变更)+/.test(item.autoNote)
          ? '100%'
          : item[percentName] === 0 || !item[percentName]
            ? '免费'
            : item[percentName] + '%';
        obj.time = t;
        return obj;
      })
      .sort((a, b) => {
        return moment(a.time).isAfter(b.time)
          ? 1
          : moment(a.time).isSame(b.time) && a.text.indexOf('后') !== -1
            ? 1
            : -1;
      });
  }
}

export function analyzeUseText(time, sign, arr, type, language) {
  if (language == 'en') {
    return arr
      .map(item => {
        let obj = {
          text: '',
          percent: 0,
        };
        const isEnd = item.flightDateEnd && item.flightDateEnd !== 0;
        const date = isEnd ? 'flightDateEnd' : 'flightDateStart';
        const unit = isEnd ? 'flightDateEndUnit' : 'flightDateStartUnit';
        const percentName = sign === 'r' ? 'percentage' : 'discountPercent';
        if (!item[unit] && !item[date]) return '';
        const t = moment(time)
          .subtract(Math.abs(item[date]), item[unit].toLocaleLowerCase())
          .format('YYYY-MM-DD HH:mm');

        // 前、后时间都为0
        if (!item.flightDateStart && !item.flightDateEnd) {
          return {
            text: `Around ${moment(time).format('MM-DD HH:mm')}`,
            percent: /(不得)+.*(退票|变更)+/.test(item.autoNote)
              ? '100%'
              : item[percentName] === 0 || !item[percentName]
                ? 'Free'
                : item[percentName] + '%',
            time,
          };
        }

        obj.text = `${
          // isEnd ? '前（包含）' : '后'
          type === 'JXFLIGHT'
            ? isEnd
              ? `Before ${moment(t).format('MM-DD HH:mm')}`
              : `After ${moment(t).format('MM-DD HH:mm')}（include）`
            : isEnd
              ? `Before ${moment(t).format('MM-DD HH:mm')}（include）`
              : `After ${moment(t).format('MM-DD HH:mm')}`
          }`;
        obj.percent = /(不得)+.*(退票|变更)+/.test(item.autoNote)
          ? '100%'
          : item[percentName] === 0 || !item[percentName]
            ? 'Free'
            : item[percentName] + '%';
        obj.time = t;
        return obj;
      })
      .sort((a, b) => {
        return moment(a.time).isAfter(b.time)
          ? 1
          : moment(a.time).isSame(b.time) && a.text.indexOf('After') !== -1
            ? 1
            : -1;
      });
  } else {
    return arr
      .map(item => {
        let obj = {
          text: '',
          percent: 0,
        };
        const isEnd = item.flightDateEnd && item.flightDateEnd !== 0;
        const date = isEnd ? 'flightDateEnd' : 'flightDateStart';
        const unit = isEnd ? 'flightDateEndUnit' : 'flightDateStartUnit';
        const percentName = sign === 'r' ? 'percentage' : 'discountPercent';
        if (!item[unit] && !item[date]) return '';
        const t = moment(time)
          .subtract(Math.abs(item[date]), item[unit].toLocaleLowerCase())
          .format('YYYY-MM-DD HH:mm');

        // 前、后时间都为0
        if (!item.flightDateStart && !item.flightDateEnd) {
          return {
            text: `${moment(time).format('MM-DD HH:mm')} 前后`,
            percent: /(不得)+.*(退票|变更)+/.test(item.autoNote)
              ? '100%'
              : item[percentName] === 0 || !item[percentName]
                ? '免费'
                : item[percentName] + '%',
            time,
          };
        }

        obj.text = `${moment(t).format('MM-DD HH:mm')} ${
          // isEnd ? '前（包含）' : '后'
          type === 'JXFLIGHT'
            ? isEnd
              ? '前'
              : '后（包含）'
            : isEnd
              ? '前（包含）'
              : '后'
          }`;
        obj.percent = /(不得)+.*(退票|变更)+/.test(item.autoNote)
          ? '100%'
          : item[percentName] === 0 || !item[percentName]
            ? '免费'
            : item[percentName] + '%';
        obj.time = t;
        return obj;
      })
      .sort((a, b) => {
        return moment(a.time).isAfter(b.time)
          ? 1
          : moment(a.time).isSame(b.time) && a.text.indexOf('后') !== -1
            ? 1
            : -1;
      });
  }
}
/**
 * upp支付
 * @param {array} arr [encodeMsg, signMsg, merAppId, merId, local]
 */
export function submitPay({
  token,
  merAppId,
  merId,
  version,
  language,
  DYurl,
}) {
  // 跳转至upp，修改store当前url
  const store_a = JSON.parse(sessionStorage.getItem('persist:emp'));
  const store_b = JSON.parse(
    JSON.parse(sessionStorage.getItem('persist:emp')).App
  );
  store_b.oldLocation.pathname = location.hash.slice(
    1,
    location.hash.indexOf('?')
  );
  store_a.App = JSON.stringify(store_b);
  sessionStorage.setItem('persist:emp', JSON.stringify(store_a));
  if (
    window.__wxjs_environment &&
    window.__wxjs_environment === 'miniprogram'
  ) {
    const url = encodeURIComponent(
      `${urlConfig.app_url}ticketRefund/#${Routes.ticket.child.updateDetail.path
      }?`
    );
    wx.miniProgram.navigateTo({
      url: `/sub/uppPayCenter/index?token=${token}&merAppId=${merAppId}&merId=${merId}&version=${version}&local=${language}&showBackUrl=${url}`,
    });
    return false;
  }
  // isTTWebView 若为 true，则是在头条小程序的 web-view 中打开
  const isTTWebView = navigator.userAgent
    .toLowerCase()
    .includes('toutiaomicroapp');
  if (isTTWebView) {
    const url = encodeURIComponent(DYurl);
    tt.miniProgram.navigateTo({
      url: `/subs/payCenter/dyPayment?merId=${merId}&merAppId=${merAppId}&token=${token}&version=${version}&jumpPath=${url}`,
    });
    return false;
  }

  window.location.href = `${urlConfig.uppPay
    }?token=${token}&merAppId=${merAppId}&merId=${merId}&version=${version}&language=${language}`;
}

// 新航班舱位排序
export function cabinSort(arr) {
  let spacearr = [
    'E/V/Z/T/N/R/G/X',
    'U/A/L/Q',
    'B/M/H/P/K',
    'Y',
    'S',
    'W',
    'C/D/I/O',
    'J',
    'F',
  ];

  let cabinLists = [];
  let trag = arr.some(it => it.giftMiles);

  arr.forEach(item => {
    /**
     * 同仓位只取一个
     */

    if (!trag) {
      spacearr = spacearr.map(child =>
        typeof child === 'string' && child.indexOf(item.cabin) !== -1
          ? item
          : child
      );
    } else {
      spacearr.forEach((child, i) => {
        if (child.indexOf(item.cabin) !== -1) {
          item.innnk = i;
          cabinLists.push(item);
        }
      });
    }
  });
  if (!trag) {
    spacearr = spacearr.filter(item => !(typeof item === 'string'));
    return spacearr;
  } else {
    return cabinLists.sort((a, b) => a.innnk - b.innnk);
  }
}

// 证件类型
export function getCertificateType(str, lang) {
  switch (str) {
    case 'NI':
      return lang.ni; // '身份证'
    case 'PP':
      return lang.pp; // '护照号'
    case 'P':
      return lang.pp; // '护照号'
    case 'ID':
      return lang.othersId; // '其他证件'
    default:
      return lang.ni;
  }
}

export function getMuCertificateType(str) {
  switch (str) {
    case '709':
      return '身份证';
    case 'HH':
      return '户口簿';
    case 'BR':
      return '出生证明';
    case 'MI':
      return '军官证';
    case 'POL':
      return '警官证';
    case '9CT':
      return '台胞证';
    case '9CC':
      return '回乡证';
    case 'TRP':
      return '台湾居民居住证';
    case 'GRP':
      return '港澳居民居住证';
    case 'PT':
      return '护照';
    case 'F1':
      return '其它';
    case '710':
      return '外国人永久居留证';
    case 'S':
      return '海员证';
    case '9PF':
      return '外国人出入境证';
    default:
      return '其它证件';
  }
}

export function getCaCertificateType(str) {
  switch (str) {
    case 'CA-RC':
      return '身份证';
    case 'CA-2RC':
      return '身份证';
    case 'PT':
      return '护照';
    case 'CA-EPT':
      return '电子护照';
    case 'CA-209':
      return '户口簿';
    case 'CA-MM':
      return '军人及武警证件';
    case 'CA-ML':
      return '通行证';
    case 'F1':
      return '其它证件';
    case 'CA-FD':
      return '外国人永久居留证';
    case 'S':
      return '海员证';
    case 'CA-DCM':
      return '外交部签发的驻华外交人员证';
    default:
      return '其它证件';
  }
}

export function getHuCertificateType(str) {
  switch (str) {
    case 'NI':
      return '身份证';
    case 'PP':
      return '护照';
    case 'JG':
      return '军官证';
    case 'WG':
      return '外国人永久居留证';
    case 'ID14':
      return '外国人永久居留证';
    case 'HM':
      return '港澳台居民居住证';
    case 'ID':
      return '其他证件';
    case 'ID1':
      return '港澳通行证';
    case 'ID2':
      return '大陆居民来往台湾通行证';
    case 'ID5':
      return '士官证';
    case 'ID10':
      return '海员证';
    case 'ID15':
      return '出生医学证明';
    case 'ID16':
      return '户口簿';
    case 'ID17':
      return '学生证';
    default:
      return '其它证件';
  }
}

// 旅客类型
export function getPsgType(peppleType, type) {
  if (peppleType === 0) {
    return '成人';
  } else if (peppleType === 1) {
    return '儿童';
  } else if (peppleType === 2) {
    // 为无陪伴儿童
    return '儿童';
  } else if (peppleType === 3) {
    return '婴儿';
  } else if (peppleType === 5) {
    return '成人';
  } else {
    return '';
  }
}

// 登录
export function allLogin(query) {
  if (isCsairApp()) {
    try {
      // 需要先判断 android 需要登出再登录， ios 直接登录
      if (window.CSNativeObject.getOSType() === 'android') {
        // 先退出，再登录，解决安卓token失效后一直死循环查不出数据问题
        window.CSNativeObject.nativeLoginOut('callback');
        window.callback = function (params) {
          window.CSNativeObject.nativeLogin('callback');
          window.callback = function (params2) {
            window.location.reload();
          };
        };
      } else {
        window.CSNativeObject.nativeLogin('callback');
        window.callback = function (params2) {
          window.location.reload();
        };
      }
    } catch (e) {
      // catch exception;
    }
  } else {
    let url = '';
    if (
      window.location.hash.indexOf(Routes.ticket.child.reformProcess.path) !==
      -1
    ) {
      url = encodeURIComponent(
        `${urlConfig.app_url}ticketRefund/#${Routes.ticket.child.reformProcess.path
        }${window.location.hash.slice(window.location.hash.indexOf('?'))}`
      );
    } else {
      url = encodeURIComponent(
        `${urlConfig.app_url}ticketRefund/#${Routes.ticket.child.updateDetail.path
        }?${toQueryString(query)}`
      );
    }
    if (
      window.__wxjs_environment &&
      window.__wxjs_environment === 'miniprogram'
    ) {
      window.location.href = `${urlConfig.login_url
        }personal_new/login/#/?t=forward&redirect=${url}&channel=ETM&loginFuncMannel=%E9%80%80%E7%A5%A8%E5%8D%95%E6%9F%A5%E8%AF%A2&sysId=ETM&loginMode=2&topBarRightCode=empty&coopAccount=`;
    } else {
      window.location.href = `${urlConfig.login_url
        }personal_new/login/#/?t=forward&redirect=${url}&channel=ETM&loginFuncMannel=%E9%80%80%E7%A5%A8%E5%8D%95%E6%9F%A5%E8%AF%A2&sysId=ETM&loginMode=0&coopAccount=`;
    }
  }
}

/**
 * @description 判断是否为公务票
 * @param {array} arr
 * @returns {bool}
 */
export function isOfficialTicket(arr = []) {
  return arr.filter(item => item.civilSeat).length > 0;
}

/**
 * @description 创建script获取微信jsdk
 */
export function createWechatSdk() {
  var oscript = document.createElement('script');
  oscript.src = 'https://res.wx.qq.com/open/js/jweixin-1.4.0.js';
  document.body.appendChild(oscript);
}
export function createFanTaiSdk() {
  var oscript = document.createElement('script');
  oscript.src =
    'https://public-1251849568.cos.ap-guangzhou.myqcloud.com/jssdk/finclip-jssdk-1.4.20.js';
  document.body.appendChild(oscript);
}

/**
 * @description 航班列表排序
 * @param {array} arr
 */
export function sortFlightList(arr) {
  if (!Array.isArray(arr)) return [];
  return arr.sort(
    (a, b) =>
      moment(
        `${a.flightDate || a.deptDate} ${a.depTime || a.deptTime}`
      ).unix() -
      moment(`${b.flightDate || b.deptDate} ${b.depTime || b.deptTime}`).unix()
  );
}
/**
 * 解析common项目跳转过来Url参数
 * urlParams=mode-easy_lastName-lian_firstName-jie_account-784123123
 * @param {String} str
 * @returns {Object} { mode: easy, lastName, firstName, account }
 */
export function parseLoginUrlParams(str) {
  return decodeURIComponent(str)
    .split('_')
    .reduce(function (a, b) {
      var before = b.match(/(\S*)-/)[1];
      var after = b.match(/-(\S*)/)[1];
      if (a[before]) {
        return a;
      }
      a[before] = after;
      return a;
    }, {});
}

/**
 * @description 保存本地数据
 * @param {string} key
 * @param data
 */
export function saveLocalData(key, data) {
  if (isCsairApp()) {
    window.CSNativeObject.saveDataLocalStorage(
      JSON.stringify({ [key]: JSON.stringify(data) })
    );
  } else {
    localStorage.setItem(key, JSON.stringify(data));
  }
}

/**
 * @description 获取本地数据
 * @param {string} key
 * @returns
 */
export function getLocalData(key) {
  let data = null;
  if (isCsairApp()) {
    data = window.CSNativeObject.getDataLocalStorage(
      JSON.stringify({ keyName: key })
    );
  } else {
    data = localStorage.getItem(key);
  }
  try {
    if (typeof data === 'string') {
      data = JSON.parse(data);
    }
  } catch (error) {
    data = null;
  }
  return data;
}

/**
 * @description 物理舱位分类
 * @param {string} cabintype 以英文逗号隔开的字符串
 * @returns {}
 */
export function physicsCabinsAssort(cabintype) {
  const cabinClass = {
    firstClass: {
      zh_cn: '头等舱',
      type: 'F',
    },
    businessClass: {
      zh_cn: '公务舱',
      type: 'J/C/D/I/O',
    },
    mzEconomyClass: {
      zh_cn: '明珠经济舱',
      type: 'W/S',
    },
    economyClass: {
      zh_cn: '经济舱',
      type: 'Y/B/M/H/P/K/U/A/L/Q/E/V/Z/T/N/R/G/X',
    },
  };
  let obj = { ...cabinClass };
  const keys = Object.keys(cabinClass);
  cabintype.split(',').forEach(type => {
    keys.forEach(key => {
      if (!obj[key]._type) obj[key]._type = '';
      if (cabinClass[key].type.indexOf(type) !== -1) {
        obj[key]._type += (!obj[key]._type ? '' : ',') + type;
      }
    });
  });
  return obj;
}

export function touchScroll(scroll) {
  var ios = navigator.userAgent.indexOf('iPhone'); //判断是否为ios
  if (ios !== -1) {
    touchScroll(scroll);
  }

  var canScroll = true;
  function touchScroll(el) {
    canScroll = false;
    //el需要滑动的元素
    el.addEventListener('touchmove', function (e) {
      canScroll = true;
    });
    document.body.addEventListener(
      'touchmove',
      function (e) {
        if (!canScroll) {
          e.preventDefault(); //阻止默认事件(上下滑动)
        } else {
          //需要滑动的区域
          var top = el.scrollTop; //对象最顶端和窗口最顶端之间的距离
          var scrollH = el.scrollHeight; //含滚动内容的元素大小
          var offsetH = el.offsetHeight; //网页可见区域高
          var cScroll = top + offsetH; //当前滚动的距离

          //被滑动到最上方和最下方的时候
          if (top == 0) {
            top = 1; //0～1之间的小数会被当成0
          } else if (cScroll === scrollH) {
            el.scrollTop = top - 0.1;
          }
        }
      },
      { passive: false }
    ); //passive防止阻止默认事件不生效
  }
}

// 身份证号码校验
export function idNoFormatCheck(num) {
  num = num.toUpperCase(); // 字符串转换为大写
  if (/^[A-KM-QT-XZ]{1}[1|2][0-9]{8}$/.test(num)) {
    return true; //台 校验码=10-通算值的末尾数
    //通算值= 首字母对应的第一位验证码 + 首字母对应的第二位验证码*9 + 性别码*8 + 第二位数字*7 + 第三位数字*6 + 第四位数字*5 + 第五位数字*4 + 第六位数字*3 + 第七位数字*2 + 第八位数字*1
  }
  if (/^[1|5|7][0-9]{6}[0−9aA][0−9aA]$/.test(num)) {
    return true; //澳
  }
  if (
    /^((\s[A-Za-z]|([A-Za-z]{2}))\d{6}(([0−9aA][0−9aA])|([0-9aA])))$/.test(num)
  ) {
    return true; //港
  }
  if (!/(^\d{15}$)|(^\d{17}([0-9]|X)$)/.test(num)) {
    return false;
  }
  var len, re;
  len = num.length;
  if (len != 15 && len != 18) {
    return false;
  }
  re = new RegExp(
    len == 15
      ? /^(\d{6})(\d{2})(\d{2})(\d{2})(\d{3})$/
      : /^(\d{6})(\d{4})(\d{2})(\d{2})(\d{3})([0-9]|X)$/
  );
  var arrSplit = num.match(re);
  var dtmBirth = new Date(
    (len == 15 ? '19' : '') +
    arrSplit[2] +
    '/' +
    arrSplit[3] +
    '/' +
    arrSplit[4]
  );
  var bGoodDay;
  bGoodDay =
    ((len == 15 && dtmBirth.getYear() == Number(arrSplit[2])) ||
      (len == 18 && dtmBirth.getFullYear() == Number(arrSplit[2]))) &&
    dtmBirth.getMonth() + 1 == Number(arrSplit[3]) &&
    dtmBirth.getDate() == Number(arrSplit[4]);
  if (!bGoodDay) {
    return false;
  }
  var valnum;
  var arrInt = new Array(7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2);
  var arrCh = new Array('1', '0', 'X', '9', '8', '7', '6', '5', '4', '3', '2');
  var nTemp = 0,
    i;
  if (len == 15) {
    num = num.substr(0, 6) + '19' + num.substr(6, num.length - 6);
  }
  for (i = 0; i < num.length - 1; i++) {
    nTemp += num.substr(i, 1) * arrInt[i];
  }
  valnum = arrCh[nTemp % 11];
  if (valnum != num.substr(num.length - 1, 1)) {
    return false;
  }
  return true;
}

// 问卷判断用户端
export function userAgentType() {
  let channel = '通用';
  if (
    window.__wxjs_environment &&
    window.__wxjs_environment === 'miniprogram'
  ) {
    channel = '小程序';
  } else if (
    (navigator.userAgent.indexOf('Android') > -1 ||
      navigator.userAgent.indexOf('Adr') > -1) &&
    isCsairApp()
  ) {
    channel = 'APP Android';
  } else if (
    !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) &&
    isCsairApp()
  ) {
    channel = 'APP IOS';
  } else if (
    navigator.userAgent.match(
      /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
    ) &&
    !isCsairApp()
  ) {
    channel = 'H5 移动';
  } else if (navigator.userAgent.match(/(Windows NT)/i)) {
    channel = 'H5 PC';
  }
  return channel;
}

// 敏感信息处理
export function encrypt(word, keyStr = 'refUnd!2#ProD%26') {
  let key = window.CryptoJS.enc.Utf8.parse(keyStr);
  let srcs = window.CryptoJS.enc.Utf8.parse(word);
  let encrypted = window.CryptoJS.AES.encrypt(srcs, key, {
    mode: window.CryptoJS.mode.ECB,
    padding: window.CryptoJS.pad.Pkcs7,
  });
  return encrypted.toString();
}

export function getOrderChannel() {
  let chan = userAgentType();
  if (chan === '小程序') {
    return 'W_XCX';
  } else if (chan === 'APP Android') {
    return 'A_A';
  } else if (chan === 'APP IOS') {
    return 'A_I';
  } else if (navigator.userAgent.toLowerCase().match(/micromessenger/i)) {
    //微信浏览器环境
    return 'W_H5';
  } else if (chan === 'H5 PC') {
    return 'T_N';
  } else if (chan === 'H5 移动') {
    return 'T_N';
  } else {
    return 'N_N';
  }
}

/**
 * 设置与获取sessionStorage
 *@public
 * @return {String}
 * */
export const session = (key, data) => {
  if (!key) {
    console.error('key不能为空');
    return '';
  }
  if (data) {
    if (typeof data === 'object') {
      sessionStorage.setItem(key, JSON.stringify(data));
    } else {
      sessionStorage.setItem(key, data);
    }
  } else {
    try {
      if (sessionStorage.getItem(key)) {
        if (
          sessionStorage.getItem(key).includes('{') ||
          sessionStorage.getItem(key).includes('[')
        ) {
          return JSON.parse(sessionStorage.getItem(key));
        }
        return sessionStorage.getItem(key);
      }
    } catch (e) {
      return sessionStorage.getItem(key);
    }
  }
};

export function getPageName(page) {
  let pageNameP = '';
  if (page) {
    if (page.includes('/ticket/updateDetail')) {
      pageNameP = '机票退改列表页';
    } else if (page.includes('/ticket/changeRefundExplain/list')) {
      pageNameP = '机票退改-退改说明选择客票页';
    } else if (page.includes('/ticket/changeRefundExplain/detail')) {
      pageNameP = '机票退改-退改说明页';
    } else if (page.includes('/ticket/selectDate')) {
      pageNameP = '机票退改-选择变更日期页';
    } else if (page.includes('/ticket/TicketChange')) {
      pageNameP = '机票退改-变更新航班页';
    } else if (page.includes('/ticket/ApplySubmit')) {
      pageNameP = '机票退改-变更提交申请页';
    } else if (page.includes('/ticket/coupon')) {
      pageNameP = '机票退改-变更优惠券列表页';
    } else if (page.includes('/ticket/addPersonMessage')) {
      pageNameP = '机票退改-补充旅客信息页';
    } else if (page.includes('/ticket/pay')) {
      pageNameP = '机票退改-支付成功页';
    } else if (page.includes('/ticket/ReformProcess')) {
      if (page.includes('orderType=T')) {
        if (page.includes('TJ')) {
          pageNameP = '机票退改-取消行程详情页';
        } else {
          pageNameP = '机票退改-退票详情页';
        }
      } else {
        pageNameP = '机票退改-变更详情页';
      }
    } else if (page.includes('/ticket/EndorsedApply')) {
      if (page.includes('ticketChangeType=refundTicket')) {
        if (page.includes('channel=TPWL')) {
          pageNameP = '机票退改-取消行程选人选航段页';
        } else {
          pageNameP = '机票退改-退票选人选航段页';
        }
      } else {
        pageNameP = '机票退改-变更选人选航段页';
      }
    } else if (page.includes('/ticket/refundApply')) {
      if (page.includes('channel=TPWL')) {
        pageNameP = '机票退改-取消行程提交申请页';
      } else {
        pageNameP = '机票退改-退票提交申请页';
      }
    } else if (page.includes('/ticket/refundCoupon')) {
      pageNameP = '机票退改-退票优惠券列表页';
    } else if (page.includes('/ticket/cancelLation')) {
      pageNameP = '机票退改-取消行程列表页';
    } else if (page.includes('/ticket/wrongPurchase')) {
      pageNameP = '机票退改-错购提交申请页';
    } else if (page.includes('/ticket/discountTicketApplication')) {
      pageNameP = '机票退改-降价客票提交申请页';
    } else if (page.includes('/ticket/feeQuery/login')) {
      pageNameP = '退改计算器-凭证号登录页';
      // } else if (page.includes()) {
      //   pageNameP = '机票退改-码上改签查询页'
    } else if (page.includes('/ticket/feeQuery/detail')) {
      pageNameP = '退改计算器-退改费用查询页';
    }
  }
  return pageNameP;
}

export function getChangeStatus(changeStatus) {
  let flag = '';
  switch (changeStatus) {
    case '0':
      flag = '审核中';
      break;
    case '1':
      flag = '审核不通过';
      break;
    case '2':
      flag = '待支付';
      break;
    case '3':
      flag = '支付中';
      break;
    case '4':
      flag = '支付失败';
      break;
    case '5':
      flag = '处理中';
      break;
    case '6':
      flag = '取消';
      break;
    case '7':
      flag = '变更失败';
      break;
    case '8':
      flag = '变更成功';
      break;
    case '14':
      flag = '人工处理';
      break;
    case '15':
      flag = '重新提单';
      break;
    case '16':
      flag = '放弃变更';
      break;
    case '17':
      flag = '已电话通知';
      break;
    case '18':
      flag = '等待处理';
      break;
    case '19':
      flag = '变更处理中';
      break;
    case '20':
      flag = '处理失败';
      break;
    default:
      break;
  }
  return flag;
}

export function getGoogleApp() {
  if (
    window.CSNativeObject &&
    typeof window.CSNativeObject.getAnalyticsSwitch == 'function'
  ) {
    return true;
  } else {
    return false;
  }
}

export function getHaiwaiApp() {
  if (
    window.CSNativeObject &&
    window.CSNativeObject.getCurrentLocaleCountryInfo &&
    typeof window.CSNativeObject.getCurrentLocaleCountryInfo == 'function'
  ) {
    try {
      window.getCountryInfo = blackResult => {
        if (typeof blackResult === 'string') {
          blackResult = JSON.parse(blackResult);
        }
        console.log(blackResult,'blackResult')
        return blackResult.countryCode
        // if (
        //   blackResult.countryCode !== 'CN'
        // ) {
        //   return true;
        // } else {
        //   return false
        // }
      };
      window.CSNativeObject.getCurrentLocaleCountryInfo(
        JSON.stringify({
          callBackMethod: 'getCountryInfo'
        })
      );
    } catch (error) {
      console.log(error);
      return false;
    }
  } else {
    return false;
  }
}


// WEBPACK FOOTER //
// ./src/utils/util.js